import {UIWGameEndController} from './UIWGameEndController'
import {UIDiscordInstance} from '../../discord/child_iframe/UIDiscordInstance'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes'
import {ViewPopupShareImage} from '../../../../shared/scripts/ui_popup/ViewPopupShareImage'
import {UIEndGameShareImage} from '../../../../shared/scripts/ui_share_image/UIEndGameShareImage'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIDGameEndController extends UIWGameEndController {
    protected isSharingEnabled(): boolean {
        if(UIUtilsEjsVariables.isUserOnDiscordMobile) return false
        return super.isSharingEnabled()
    }

    protected async shareButtonAction() {
        const shareImagePopup = this.titleImage == undefined ? new ViewPopupShareImage(this.shareImage) : new ViewPopupShareImage(this.titleImage, this.shareImage, true)

        const shareAction = async(image: UIEndGameShareImage) => {
            const imageFile = await image.getImageFile()
            if(imageFile == undefined) return

            void UIDiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.ShareMoment, imageFile)

            UIDGameEndController.sendDiscordShareAnalytic()
        }

        shareImagePopup.setShareAction(shareAction)
    }

    private static sendDiscordShareAnalytic() {
        const discordShareClickEvent: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.EndGameShareButton,
            category: AnalyticEventCategory.Virality,
            floatValue: AnalyticEventValue.EndGameShareDiscordButton,
        }
        void CA.sendAnalyticEventOnce(discordShareClickEvent)
    }
}
